<template>
    <div class="page-wrapper">
        <delete-article-window
                :visible="deleteWindowVisible"
                :id="article.id"
                :name="article.header"
                @close-window="closeDeleteWindow"/>
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container col2">
                    <div class="container-left">
                        <UserMenu/>
                    </div>
                    <div class="container-right">
                        <div class="admin-article-edit">
                            <router-link :to="{name: 'AdminArticleList'}" class="back"><i
                                    class="fa fa-long-arrow-left"></i>назад
                            </router-link>
                            <div class="page-title cabinet-page-title visibility">
                                {{ !!article.id ? 'Редактировать статью' : 'Новая статья'}}
                            </div>

                            <div class="admin-form-wrapper">
                                <div class="admin-form-row">
                                    <label>Заголовок *:</label>
                                    <input type="text" autocomplete="off" required=""
                                           v-model="article.header">
                                </div>
                                <div class="admin-form-row">
                                    <label>Дата *:</label>
                                    <date-picker
                                            v-model="article.date"
                                            format="DD.MM.YYYY"
                                            lang="ru"
                                            v-mask="'##.##.####'"
                                            placeholder="дд.мм.гггг"
                                            value-type="date"
                                            :input-attr="{ required: 'true' }"
                                            :clearable="false"
                                            :first-day-of-week="1">
                                        <template slot="calendar-icon">&nbsp;</template>
                                    </date-picker>
                                </div>
                                <div class="admin-form-row">
                                    <label>Изображение:</label>
                                    <div class="img-container-wrapper">
                                        <div class="img-container">
                                            <img :src="getArticleImage">
                                        </div>
                                        <div class="img-btn-container">
                                            <button type="button" class="small-button small-button-f blue-button"
                                                    @click="$refs.imageFile.click()">
                                                <input type="file" @change="startImageUpload($event)"
                                                       style="display: none;"
                                                       ref="imageFile"
                                                       :disabled="mediaFileUploading">
                                                {{ !!article.hasImage ?
                                                'Заменить изображение' :
                                                'Установить изображение статьи' }}
                                            </button>
                                            <button type="button" class="small-button small-button-f red-button"
                                                    v-show="!!article.hasImage"
                                                    @click="deleteArticleImage">Удалить изображение
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="admin-form-row admin-form-full">
                                    <label>Текст статьи *:</label>
                                    <custom-text-editor
                                            v-model="article.textContent"/>
                                </div>
                                <div class="admin-form-row admin-form-access-article">
                                    <div class="title">Кто может читать статью:</div>
                                    <label><input type="radio" name="access-article"
                                                  :value="articleStatuses.FOR_ALL" v-model="article.status">
                                        <span>Все пользователи</span></label>
                                    <label><input type="radio" name="access-article"
                                                  :value="articleStatuses.ONLY_AUTH" v-model="article.status">
                                        <span>Авторизованные</span></label>
                                    <label><input type="radio" name="access-article"
                                                  :value="articleStatuses.ONLY_PRO" v-model="article.status">
                                        <span>Только PRO</span></label>
                                </div>
                                <div class="admin-form-row admin-form-btns">
                                    <button type="button" class="button red-button"
                                            v-if="!!article.id"
                                            @click="showDeleteWindow">Удалить
                                    </button>
                                    <button type="button" class="button blue-button"
                                            @click="sendSaveRequest">Сохранить
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import utils from '@/utils';
    import moment from 'moment';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import UserMenu from '@/components/UserMenu';
    import CustomTextEditor from '@/components/CustomTextEditor';
    import DeleteArticleWindow from "@/components/window/DeleteArticleWindow";
    import DatePicker from 'vue2-datepicker';
    import {mask} from 'vue-the-mask';
    import fileUploader from '@/file-uploader';

    const emptyArticle = {
        id: null,
        date: null,
        code: null,
        header: null,
        textContent: null,
        hasImage: false,
        status: constants.articleStatus.FOR_ALL
    };

    export default {
        name: "AdminArticleEdit",

        directives: {mask},

        components: {
            Header, Footer, UserMenu, CustomTextEditor, DeleteArticleWindow, DatePicker
        },

        data() {
            return {
                deleteWindowVisible: false,
                article: Object.assign({}, emptyArticle),

                base64Image: null,
                mediaFileUploading: false,

                defaultArticleImage: require('@/image/default_article_image.jpg')
            }
        },

        async created() {
            let articleId = this.$route.params.id;
            if (Number(articleId) > 0) {
                let article = await this.$store.dispatch('getArticle', articleId);
                if (!article) {
                    this.$router.push({name: 'AdminArticleList'});
                    return;
                }

                this.article = article;
            } else if (!!articleId && articleId !== 'new') {
                this.$router.push({name: 'AdminArticleList'});
            }
        },

        computed: {
            getArticleImage() {
                if (!!this.base64Image)
                    return this.base64Image;
                else if (!!this.article.id && !!this.article.hasImage)
                    return process.env.VUE_APP_GLOBAL_URL + `/document/article-image/${this.article.id}`;
                else
                    return this.defaultArticleImage;
            },

            articleStatuses() {
                return constants.articleStatus;
            }
        },

        methods: {
            async sendSaveRequest() {
                let date = moment(utils.createDateAsUTC(new Date(moment(this.article.date, "DD.MM.YYYY")
                        .set({hour: 0, minute: 0, second: 0, millisecond: 0})
                        .valueOf()))).valueOf();

                let data = {
                    date: date,
                    header: this.article.header,
                    textContent: this.article.textContent,
                    base64Image: this.base64Image,
                    status: this.article.status
                };

                let articleId = Number(this.article.id);
                let existingArticle = articleId > 0;

                let article = await (existingArticle ?
                        this.$store.dispatch('updateArticle', [articleId, data]) :
                        this.$store.dispatch('createArticle', data));

                if (article != null) {
                    alert('Статья была сохранена');
                    setTimeout(() => {
                        this.$router.push({name: 'AdminArticleList'})
                    }, 500);
                }
            },

            async deleteArticleImage() {
                this.base64Image = null;
                if (!!this.article.id
                        && !!this.article.hasImage) {
                    let success = await this.$store.dispatch('deleteArticleImage', this.article.id);
                    if (success) {
                        this.article.hasImage = false;
                    }
                }
            },

            showDeleteWindow() {
                this.deleteWindowVisible = true;
            },

            closeDeleteWindow(payload) {
                this.deleteWindowVisible = false;
                if (!!payload.reload) {
                    this.$router.push({name: 'AdminArticleList'});
                }
            },

            async startImageUpload(event) {
                if (this.mediaFileUploading)
                    return;

                this.mediaFileUploading = true;
                try {
                    let result = await fileUploader.uploadImage(event);
                    this.base64Image = result.content;
                } catch (error) {
                    alert('Не удалось загрузить изображение!');
                } finally {
                    this.mediaFileUploading = false;
                }
            },
        }
    }
</script>